var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-data-table", {
    staticClass: "elevation-1 secondarybackground striped-table",
    attrs: {
      dense: "",
      "hide-default-footer": "",
      "fixed-header": "",
      "disable-sort": "",
      "calculate-widths": "",
      "items-per-page": _vm.page_sizes[_vm.pageSizeIndex],
      headers: _vm.headers,
      items: _vm.items,
      height: "35vh",
      "no-data-text": _vm.generateMessage("requests.logs.noItems"),
      loading: _vm.isLoadingItems
    },
    scopedSlots: _vm._u([
      {
        key: "top",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "d-flex justify-end" },
              [
                _vm.items.length > 0
                  ? _c("custom-btn-icon", {
                      attrs: {
                        loading: _vm.isDownloading,
                        color: "success",
                        icon: "mdi-file-excel",
                        "tooltip-text": "Export Excel"
                      },
                      on: { click: _vm.handleExcelExportClick }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("custom-page-selector", {
                  attrs: { namespace: "requests/logs" }
                })
              ],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "item.description",
        fn: function({ item }) {
          return [
            _c("div", { staticClass: "caption" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm._f("showDate")(item.datetime)) +
                  "\n      "
              ),
              item.application_fullname
                ? _c("div", [
                    _vm._v("\n        Créé par\n        "),
                    _c("span", { staticClass: "primary--text" }, [
                      _vm._v(_vm._s(item.application_fullname))
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "font-weight-bold" }, [
                _vm._v("\n        " + _vm._s(item.description) + "\n      ")
              ])
            ])
          ]
        }
      },
      {
        key: "item.recipient",
        fn: function({ item }) {
          return [
            item.recipient_lastname
              ? _c("div", { staticClass: "primary--text" }, [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        item.recipient_firstname + " " + item.recipient_lastname
                      ) +
                      "\n    "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            item.recipient_employee_id
              ? _c(
                  "div",
                  { staticClass: "d-flex" },
                  [
                    _c("v-icon", [_vm._v("person")]),
                    _vm._v(" "),
                    _c("copy-to-clipboard", {
                      attrs: { message: item.recipient_employee_id }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            item.phone_number
              ? _c(
                  "div",
                  { staticClass: "d-flex" },
                  [
                    _c("v-icon", [_vm._v("phone")]),
                    _vm._v(" "),
                    _c("copy-to-clipboard", {
                      attrs: { message: item.phone_number }
                    })
                  ],
                  1
                )
              : _vm._e()
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }